import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { ComponentRegistry } from 'core/index';

import { Section } from 'legacyComponents/layout/section';
import { Button, Spinner } from 'components';
import { media } from 'legacyComponents/styled/styleUtils';

import { modalStore } from 'apps/modals/app';
import { ButtonsWrapper as ButtonsWrapperBase } from 'apps/repository/styles';

import { OpenIssuesTab } from 'apps/issueTracker/views/openIssuesTab';
import { ClosedIssuesTab } from 'apps/issueTracker/views/closedIssuesTab';
import { LabelsTab } from 'apps/issueTracker/views/labelsTab';
import { ColorOption } from 'apps/issueTracker/views/colorOption';
import { ColorSelection } from 'apps/issueTracker/views/colorSelection';
import { LabelItem } from 'apps/issueTracker/views/labelItem';
import { NewLabelForm } from 'apps/issueTracker/views/newLabelForm';

ComponentRegistry.add('issueTracker.colorOption', ColorOption);
ComponentRegistry.add('issueTracker.colorSelection', ColorSelection);
ComponentRegistry.add('issueTracker.labelItem', LabelItem);

@withNamespaces()
@observer
export class IssueTracker extends React.Component {
  clickOpenIssue = () => {
    this.props.manager.OpenIssueForm();
  };

  clickNewLabel = () => {
    const {
      manager: { issueTracker },
    } = this.props;
    modalStore.SetModalComponent(NewLabelForm, { issueTracker });
  };

  render() {
    const { manager, projectManager } = this.props;
    const { issueTracker } = manager;
    const { project } = projectManager;
    if (issueTracker === null || project === null) {
      return (
        <Section title='Open Tasks'>
          <Spinner margin='0 auto' />
        </Section>
      );
    }

    return (
      <>
        <Section
          title='Open Tasks'
          subTitle={`(${issueTracker.openIssuesCount})`}
        >
          <ButtonsWrapper>
            <Button
              text={<Trans>New Task</Trans>}
              size='small'
              icon='add'
              iconPosition='right'
              onClick={this.clickOpenIssue}
            />
          </ButtonsWrapper>
          <OpenIssuesTab
            app={issueTracker}
            manager={manager}
            project={project}
          />
        </Section>
        <Section
          title='Closed Tasks'
          subTitle={`(${issueTracker.closedIssuesCount})`}
        >
          <ClosedIssuesTab
            app={issueTracker}
            manager={manager}
            project={project}
          />
        </Section>
        <Section title='Labels' last>
          {project && project.inSpace.whichTypes.includes('TrackerLabel') && (
            <ButtonsWrapper>
              <Button
                text={<Trans>New Label</Trans>}
                size='small'
                onClick={this.clickNewLabel}
                icon='add'
              />
            </ButtonsWrapper>
          )}
          <LabelsTab app={issueTracker} manager={manager} project={project} />
        </Section>
      </>
    );
  }
}

const ButtonsWrapper = styled(ButtonsWrapperBase)`
  ${media.xs`
  display: block;
`};
`;

IssueTracker.propTypes = {
  title: PropTypes.string,
  project: PropTypes.object,
  projectManager: PropTypes.object,
  manager: PropTypes.object,
};
